// extracted by mini-css-extract-plugin
export default {"popup":"ConfirmationPopup__popup--2wa","inner":"ConfirmationPopup__inner--3Zi","content":"ConfirmationPopup__content--3Du","btn":"ConfirmationPopup__btn--KwC"};